export enum plmUserRoleEnum {
    FSE = 'FSE', // mobile app field service engineer access
    BIOMED = 'BIOMED', // mobile app biomed access
    DEALER = 'DEALER'// mobile app dealer access
}

export enum plcUserRoleEnum {
    PLC_ADMIN = 'PLC_ADMIN', // internal application user admin access
    PLC_GUEST = 'PLC_GUEST' // external application user interface access 
}